import styles from "./ElementTooltipSeparator.module.scss";

function ElementTooltipSeparator() {
  return <div className={styles["tooltip__separator"]} />;
}

export default ElementTooltipSeparator;
